<template>
  <p style="height: 35px">
    <Button type="primary" :loading="loading" @click="save()" v-show="savePermission">
      <span v-if="!loading">{{$t('page.common.save')}}</span>
      <span v-else>{{$t('page.common.save')}}...</span>
    </Button>
    <Button v-show="!hideBackBtn" style="margin-left: 10px" @click="back()">{{$t('page.common.cancel')}}</Button>
    <slot></slot>
  </p>
</template>
<script>
/**
* @saveBeforeEvent（model） 保存前置事件,用于前置校验等、若对 当前 model 属性赋值  $callbackMsg =false 则会取消保存动作
* @saveAfterEvent（result，model） 保存前置事件,用于前置校验等、若对 当前 result 属性赋值  $callbackMsg =false 则会取消返回
*/
  export default {
    name: 'abSave',
    props: {
      'url':{required: true}, // 保存数据请求的url
      'model':{required: true}, // 保存的数据
      "method":{default:"post"}, // 提交方式 默认post 可以改为 postForm
      "hideBackBtn" :{required: false,default:false}, //是否隐藏 back 按钮
      "savePermission" :{required: false,default:true},
      "backRouter":{required: false}, // 成功后跳转页,默认前一页
      "formRef":{required: false},//校验的表单。如果为空则不校验
    },
    data() {
      return {
        loading:false,
      }
    },
    methods: {
   	  save(){
   		if(this.formRef){
   			if(this.$vnode.context.$refs[this.formRef]){
   				this.$vnode.context.$refs[this.formRef].validate((valid) => {
                    if (!valid) {
                    	this.$Message.error($t('page.common.formInvalidate'));
                    	return ;
                    }else{
                    	this.toSave();
                    }
                })
   			}else{
   				console.warn("ab-save 表单校验，formRef 查找失败、请确认 Form 组件是否添加 ref"+this.formRef);
   			}
   		}else{
   			this.toSave();
   		}
   	  },
      toSave() { 
   		this.model.$callbackMsg = true;
   		this.$emit("saveBeforeEvent", this.model);
   		// 事件返回 false 则不进行保存 saveBeforeEvent 为业务校验入口
   		if(!this.model.$callbackMsg){ return ; }
   		delete this.model.$callbackMsg;
   		
        this.loading = true;
        
        // doValidate
        let self = this;
    	let rtn = this.abHttpUtil[this.method](this.url, this.model);
    	
        rtn.then(function(data) {
          self.loading = false;
          if(data.isOk) {
            if(self.afterSave) {
              return self.afterSave(data);
            }
            self.$Message.success(data.msg);
            
            // 后置动作
            data.$callbackMsg = true;
            self.$emit("saveAfterEvent",data,self.model);
       		if(!data.$callbackMsg){ return ; }
            
       		// back
       		if(!self.hideBackBtn){
	            self.back(true);
       		}
          } else {
          	self.$Message.error(data.msg);
          }
        },function(errorCode) {
        	self.loading = false;
      		self.$Message.error("请求失败!" + errorCode);
        });
      },
      back(reload){
    	  this.$store.dispatch('admin/page/close', {
    		    tagName: this.$route.path,
    		    noSkip:true
    		});
    	
        if(this.backRouter){
          //先清理缓存,返回后起到刷新作用
          this.$router.push({
	              name: this.backRouter  ,
	              params:{reload:reload}
	          })
        }else{
          this.$router ? this.$router.back() : window.history.back();
       }
      }
    }
  }
</script>
